import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
    AmountInput,
    BusinessesRow,
    GroupMembers,
    ReadonlyAmount,
    ReportedStatus,
    RowLabel,
    SectionCard,
    TrackingFields,
    ValuesTable,
} from './SectionParts';

export const VAT_ROWS = [
    { field: 'incomesNoZeroVats', labelKey: 'FollowUpExemptTransactions' },
    { field: 'incomesNoVat', labelKey: 'FollowUpTaxableTransactions' },
    { field: 'vatTransactions', labelKey: 'FollowUpVatOnTransactions' },
    { field: 'equipmentVAT', labelKey: 'FollowUpEquipmentInputVat' },
    { field: 'otherVATTaxes', labelKey: 'FollowUpRegularInputVat' },
];

const VatSection = ({
    vat,
    periodLabel,
    fileNumber,
    reportingType,
    tracking,
    onReportChange,
    onCopy,
    onReport,
    reportDisabled,
    onTrackingChange,
    direction,
}) => {
    const { t } = useTranslation();

    return (
        <SectionCard title={t('FollowUpVatTitle')} fileNumber={fileNumber} reportingType={reportingType}>
            {vat ? (
                <>
                    <ReportedStatus isReported={vat.isReported} onReport={onReport} disabled={reportDisabled} />
                    <ValuesTable periodLabel={periodLabel} columns={[t('FollowUpBooks'), t('FollowUpReport')]}>
                        {VAT_ROWS.map(({ field, labelKey }) => (
                            <React.Fragment key={field}>
                                <RowLabel>{t(labelKey)}</RowLabel>
                                <ReadonlyAmount value={vat.books[field]} />
                                <AmountInput
                                    value={vat.report[field]}
                                    onChange={(value) => onReportChange(field, value)}
                                    ariaLabel={t(labelKey)}
                                    mismatch={vat.mismatch[field]}
                                />
                            </React.Fragment>
                        ))}
                        <RowLabel>{t('FollowUpToPayOrRefund')}</RowLabel>
                        <ReadonlyAmount value={vat.books.toPay} total />
                        <ReadonlyAmount value={vat.reportToPay} total mismatch={vat.mismatch.toPay} />
                        <BusinessesRow count={vat.businessesCount} onCopy={onCopy} />
                    </ValuesTable>
                    <GroupMembers members={vat.members} />
                </>
            ) : null}
            <TrackingFields tracking={tracking} onChange={onTrackingChange} direction={direction} />
        </SectionCard>
    );
};

VatSection.propTypes = {
    vat: PropTypes.object,
    periodLabel: PropTypes.string,
    fileNumber: PropTypes.string,
    reportingType: PropTypes.string,
    tracking: PropTypes.object.isRequired,
    onReportChange: PropTypes.func.isRequired,
    onCopy: PropTypes.func.isRequired,
    onReport: PropTypes.func,
    reportDisabled: PropTypes.bool,
    onTrackingChange: PropTypes.func.isRequired,
    direction: PropTypes.string,
};

export default VatSection;
